"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _reactToastify = require("react-toastify");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])));

var StyledUsername = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding-top: 1rem;\n  margin-bottom: ", ";\n  font-size: 1.25rem;\n"])), function (p) {
  return p.noMargin ? 0 : "2rem";
});

var StyledIconWrapper = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n  position: absolute;\n  top: -3px;\n  right: -3px;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 50%;\n  border: 3px solid white;\n"])), function (p) {
  return p.theme.colorAccentText;
}, function (props) {
  return props.theme.colorAccent;
});

var StyledAvatarWrapper = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  cursor: ", ";\n  font-size: 0;\n  border-radius: 50%;\n"])), function (p) {
  return !p.disableProfileImage ? "cursor" : "default";
});

var ProfileImage = function ProfileImage(_ref) {
  var translations = _ref.translations,
      onError = _ref.onError,
      getProfile = _ref.getProfile,
      username = _ref.username,
      image = _ref.image,
      hideGamblingReferences = _ref.hideGamblingReferences,
      hideLow6Button = _ref.hideLow6Button,
      disableProfileImage = _ref.disableProfileImage,
      ctaUrl = _ref.ctaUrl,
      ctaIconUrl = _ref.ctaIconUrl,
      ctaText = _ref.ctaText;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      isSaving = _useState2[0],
      setSaving = _useState2[1];

  var inputRef = (0, _react.useRef)();

  var saveImage = function saveImage(params) {
    setSaving(true);

    _axios.default.post("/me/image", params).then(function (_ref2) {
      var data = _ref2.data;
      getProfile(); // dispatch(getProfile());

      setSaving(false);

      _reactToastify.toast.success(translations.imageUpdated);
    }).catch(function (_ref3) {
      var response = _ref3.response;
      setSaving(false);
      onError(response);
    });
  };

  var handleClick = function handleClick() {
    if (!disableProfileImage) {
      inputRef.current.click();
    }
  };

  var handleChange = function handleChange(e) {
    var formData = new FormData();
    formData.append(e.target.name, e.target.files[0]);
    saveImage(formData);
  };

  return /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Card, null, /*#__PURE__*/_react.default.createElement(StyledWrapper, null, username ? /*#__PURE__*/_react.default.createElement(StyledAvatarWrapper, {
    disableProfileImage: disableProfileImage,
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Avatar, {
    size: "90px",
    src: image
  }), !disableProfileImage && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledIconWrapper, null, isSaving ? /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Spinner, {
    lineWidth: 2,
    forDark: true,
    primaryColor: "white"
  }) : /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.MatIcon, {
    size: "20px"
  }, "add")), /*#__PURE__*/_react.default.createElement("input", {
    ref: inputRef,
    type: "file",
    name: "image",
    style: {
      display: "none"
    },
    onChange: handleChange
  }))) : /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Skeleton, {
    skeletonWidth: "90px",
    skeletonHeight: "90px",
    isCircle: true
  }), /*#__PURE__*/_react.default.createElement(StyledUsername, {
    noMargin: hideGamblingReferences
  }, username ? username : /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Skeleton, null)), !hideGamblingReferences && /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
    style: {
      marginBottom: "0.5rem"
    },
    to: "/wallet",
    isSuccess: true
  }, translations.openWallet), !hideLow6Button && /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Low6Button, {
    ctaUrl: ctaUrl,
    ctaIconUrl: ctaIconUrl,
    ctaText: ctaText
  })));
};

var _default = ProfileImage;
exports.default = _default;